/**
 * BudgetAmountInputTypeService
 * Service for BudgetAmountInputType lookup CRUD operations
 * (1 Fixed / 2 DerivedFromItems).
 */
import { CrudService } from '../base/CrudService';
/** Service for BudgetAmountInputType CRUD operations */
export class BudgetAmountInputTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BudgetAmountInputTypeService.DEFAULT_SERVICE_PATH,
            basePath: BudgetAmountInputTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BudgetAmountInputTypeService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetAmountInputTypeService.BASE_PATH = 'api/budget-amount-input-types';
//# sourceMappingURL=BudgetAmountInputTypeService.js.map